var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSparkArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 15,
    viewBox: "0 0 103 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.707 8.07136C103.098 7.68084 103.098 7.04768 102.707 6.65715L96.3431 0.29319C95.9526 -0.0973344 95.3195 -0.0973344 94.9289 0.29319C94.5384 0.683714 94.5384 1.31688 94.9289 1.7074L100.586 7.36426L94.9289 13.0211C94.5384 13.4116 94.5384 14.0448 94.9289 14.4353C95.3195 14.8259 95.9526 14.8259 96.3431 14.4353L102.707 8.07136ZM0 7.36426V8.36426H102V7.36426V6.36426H0V7.36426Z",
    fill: "#407731"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkArrow);
export default __webpack_public_path__ + "static/media/SparkArrow.2960bfce69c271924c21f3e24ba574ff.svg";
export { ForwardRef as ReactComponent };